export default __webpack_public_path__ + "static/media/orowealth.609d4231.svg";